<template>
  <ListOrder :indentType="indentType" @change-route="redirectRoute" />
</template>

<script>
import { mapGetters } from 'vuex';
import ListOrder from './list';

export default {
  name: 'InboundIndents',
  components: {
    ListOrder,
  },
  computed: {
    ...mapGetters({
      bootstrapData: 'app/bootstrapData',
    }),
  },
  created() {
    const hideInbound = this.$hasPermission('hide_inbound_indents_selection') || false;
    if (!hideInbound && (['INBOUND', 'BOTH'].includes(this.bootstrapData.initial_landing_page_settings))) {
      this.$router.push({ name: 'InboundIndents' });
    } else {
      this.$router.push({ name: 'OutboundIndents' });
    }
    this.indentType = this.$route.meta.title;
  },
  methods: {
    redirectRoute() {
      this.$router.push({ name: 'OutboundIndents' });
    },
  },
};
</script>
